export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zapisz"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jeśli to widzisz, formularz nie został odebrany (ale nie powinieneś tego widzieć)"])}
}